module.exports = __webpack_public_path__ + "img/2.936a10a4.jpg";